
import FF_Module from './FF_Module'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs
import { ff_ajax } from '../utils/ajax';

/**
 * Module qui gère les liens qui télécharge des fichiers "zip" de fichiers en AJAX.
 */
export default class FF_Zip_Files_Download_Link extends FF_Module {

  /**
   * Initialise le module.
   */
  init() {

    this.zip_file_name = $(this.elements.container).attr('data-zip-file-name');
    this.files = $(this.elements.container).attr('data-zip-files');
    if (this.files) {
      this.files = JSON.parse(this.files);
    }
    $(this.elements.container).removeAttr('data-zip-files data-zip-file-name');

    // Ajout de l'écouteur au clic qui va créer le fichier zip en ajax
    $(this.elements.container).on('click', this.download_zip_file.bind(this));

  }

  /**
   * Crée, en AJAX, et télécharge le fichier zip des fichiers dans this.files.
   * @async
   */
  download_zip_file() {

    // Bail s'il n'y a pas de fichier
    if (!this.files) return;

    // Ajout d'un état de chargement
    $(this.elements.container).css('pointerEvents', 'none');
    $('html').addClass('is-loading');

    // Si le bouton est un FF_Pill_Button, on ajoute son état de chargement
    if (typeof this.elements.container.ff_module_instances.FF_Pill_Button !== 'undefined') {
      this.elements.container.ff_module_instances.FF_Pill_Button.add_loading_state();
    }

    // Appel ajax
    ff_ajax({
      dataType: 'json',
      data    : {
        action       : 'download-zip-file',
        zip_file_name: this.zip_file_name,
        files        : this.files
      },
      complete: () => {
        if (typeof this.elements.container.ff_module_instances.FF_Pill_Button !== 'undefined') {
          this.elements.container.ff_module_instances.FF_Pill_Button.remove_loading_state();
        }
        $(this.elements.container).css('pointerEvents', '');
        $('html').removeClass('is-loading');
      },
      success: (json) => {

        // Bail si erreur
        if (!json.success || typeof json.data.zip_file_url === 'undefined') {
          console.error('Une erreur s\'est produite lors de la requête AJAX.');
          if (typeof json.data.error !== 'undefined') {
            console.error(json.data.error);
          }
          return;
        }

        // Si succès, créé un faux lien temporaire et télécharge le zip
        const link_element = document.createElement('a');
        $(link_element)
          .attr({
            href    : json.data.zip_file_url,
            download: ''
          })
          .css({
            position: 'absolute',
            left    : '-9999px',
            opacity : 0
          })
          .appendTo('body');
        link_element.click();
        link_element.remove();

      }
    });

  }

}
